import * as React from "react";
const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L11 11M1 11L11 1", stroke: "#3F72AF", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgClose;
